import './svg.scss';

import React from 'react';

export const ChevronLeftSVGIcon = () => (
  <svg
    className="chevron-left-svg-icon svg-icon"
    viewBox="0 0 7 13"
    xmlns="http://www.w3.org/2000/svg">
    <path
      className="stroke"
      d="M6 11.4167L1 6.20833L6 1"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronRightSVGIcon = () => (
  <svg
    className="chevron-right-svg-icon svg-icon"
    viewBox="0 0 5 11"
    xmlns="http://www.w3.org/2000/svg">
    <path
      className="stroke"
      d="M1 9.88867L3.5 5.88867L1 1.88867"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronLeft1SVGIcon = () => {
  return (
    <svg
      className="chevron-left1-svg-icon svg-icon"
      viewBox="0 0 14 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className="fill"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1149 0.996566C13.6691 1.61233 13.6192 2.56077 13.0034 3.11495L4.24227 11L13.0034 18.8851C13.6192 19.4393 13.6691 20.3877 13.1149 21.0035C12.5608 21.6192 11.6123 21.6691 10.9966 21.115L0.996553 12.115C0.680482 11.8305 0.5 11.4252 0.5 11C0.5 10.5748 0.680482 10.1695 0.996553 9.88507L10.9966 0.885072C11.6123 0.330883 12.5608 0.380801 13.1149 0.996566Z"
      />
    </svg>
  );
};

export const ChevronLeft2SVGIcon = () => {
  return (
    <svg className="chevron-left2-svg-icon svg-icon" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className="fill" fillRule="evenodd" clipRule="evenodd" d="M11.5687 19.1145C11.0399 19.612 10.2153 19.612 9.68655 19.1145L-8.74228e-07 10L9.68655 0.885488C10.2153 0.387971 11.0399 0.387971 11.5687 0.885487C12.1449 1.42772 12.1449 2.34351 11.5687 2.88574L4.00792 10L11.5687 17.1143C12.1449 17.6565 12.1449 18.5723 11.5687 19.1145Z" />
    </svg>
  )
}

export const ChevronRight1SVGIcon = () => {
  return (
    <svg
      className="chevron-right1-svg-icon svg-icon"
      viewBox="0 0 12 18"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className="stroke"
        d="M2 16L10 9L2 2"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronRight2SVGIcon = () => {
  return (
    <svg
      className="chevron-right1-svg-icon svg-icon"
      viewBox="0 0 12 18"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className="stroke"
        d="M2 16L10 9L2 2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronRight3SVGIcon = () => {
  return (
    <svg className="chevron-right3-svg-icon svg-icon" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className="fill" fillRule="evenodd" clipRule="evenodd" d="M0.431318 0.885491C0.960061 0.387973 1.78471 0.387973 2.31345 0.88549L12 10L2.31345 19.1145C1.78471 19.612 0.960061 19.612 0.431319 19.1145V19.1145C-0.144949 18.5723 -0.144949 17.6565 0.431318 17.1143L7.99207 10L0.431318 2.88575C-0.14495 2.34351 -0.144949 1.42773 0.431318 0.885491V0.885491Z" />
    </svg>
  )
}

export const ChevronDownSVGIcon = () => {
  return (
    <svg
      className="chevron-down-svg-icon svg-icon"
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className="stroke"
        d="M1 1L7 7L13 1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronUpSVGIcon = () => {
  return (
    <svg
      className="chevron-up-svg-icon svg-icon"
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className="stroke"
        d="M13,7L7,1L1,7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronDoubleDownSVGIcon = () => (
  <svg
    className="chevron-double-down-svg-icon svg-icon"
    viewBox="0 0 39 11"
    xmlns="http://www.w3.org/2000/svg">
    <path
      className="stroke"
      d="M1 1L19.5 7L38 1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="stroke"
      d="M1 4L19.5 10L38 4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronDoubleLeftSVGIcon = () => (
  <svg
    className="chevron-double-left-svg-icon svg-icon"
    viewBox="0 0 13 16"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 1L7 8L12 15"
      className="stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 1L1 8L6 15"
      className="stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRightSVGIcon = () => (
  <svg
    className="arrow-right-svg-icon svg-icon"
    viewBox="0 0 10 10"
    xmlns="http://www.w3.org/2000/svg">
    <path
      className="stroke"
      d="M5.53929 9C5.53929 9 7.64851 6.47021 9 5M9 5C5.87581 5 1 5 1 5M9 5C7.64851 3.34601 6.89078 2.65399 5.53929 1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRight1SVGIcon = () => {
  return (
    <svg
      className="arrow-right1-svg-icon svg-icon"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg">
      <g opacity="1">
        <g clipPath="url(#clip0)">
          <path
            className="fill"
            d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
          />
          <path
            className="stroke"
            d="M17 22L23 16M23 16L17 10M23 16H9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0">
          <path
            d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ArrowDownSVGIcon = () => {
  return (
    <svg
      className="arrow-down-svg-icon svg-icon"
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className="stroke"
        d="M9 6L5 10M5 10L1 6M5 10L5 1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowDownDiscSVGIcon = () => (
  <svg
    className="arrow-down-disc-svg-icon svg-icon"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <path
      className="fill"
      d="M11.54 0C5.16998 0 0 5.16 0 11.54C0 17.91 5.15998 23.08 11.54 23.08C17.91 23.08 23.08 17.92 23.08 11.54C23.08 5.16 17.91 0 11.54 0ZM16.8 12.39L12.14 17.98C11.83 18.36 11.25 18.36 10.93 17.98L6.26999 12.39C5.94999 12.01 6.22 11.44 6.72 11.44H8.50998C8.94998 11.44 9.29999 11.09 9.29999 10.65V6.35C9.29999 5.88 9.67998 5.51 10.14 5.51H12.95C13.42 5.51 13.79 5.89 13.79 6.35V10.65C13.79 11.09 14.14 11.44 14.58 11.44H16.35C16.84 11.43 17.11 12.01 16.8 12.39Z"
    />
  </svg>
);

export const RightArrowSVGIcon = () => (
  <svg
    className="right-arrow-svg-icon svg-icon"
    viewBox="0 0 10 10"
    xmlns="http://www.w3.org/2000/svg">
    <path
      className="stroke"
      d="M5.53929 9C5.53929 9 7.64851 6.47021 9 5M9 5C5.87581 5 1 5 1 5M9 5C7.64851 3.34601 6.89078 2.65399 5.53929 1"
      strokeOpacity="0.5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HomeSVGIcon = () => (
  <svg
    className="home-svg-icon svg-icon"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg">
    <path
      className="fill stroke"
      d="M8.46378 0.924477L8.46378 0.924475L8.46282 0.925163L1.63575 5.86327C1.63559 5.86339 1.63543 5.8635 1.63527 5.86362C1.09464 6.25105 0.75 6.90546 0.75 7.59926V16.3188C0.75 16.8309 1.16704 17.25 1.67941 17.25H6.80892C7.32129 17.25 7.73832 16.8309 7.73832 16.3188V13.083C7.73832 12.403 8.27246 11.8684 8.94905 11.8684C9.62564 11.8684 10.1598 12.403 10.1598 13.083V16.3188C10.1598 16.8309 10.5768 17.25 11.0892 17.25H16.2866C16.7961 17.25 17.2028 16.8386 17.2488 16.3777L17.25 16.3653V16.3528V7.59926C17.25 6.90547 16.9054 6.25107 16.3647 5.86363C16.3646 5.86351 16.3644 5.86339 16.3642 5.86327L9.53718 0.925163L9.53718 0.92516L9.53622 0.924477C9.2114 0.691841 8.7886 0.691841 8.46378 0.924477ZM15.3912 7.59926V15.4216H12.0186V13.083C12.0186 11.4128 10.6504 10.04 8.98302 10.04C7.31566 10.04 5.94745 11.4128 5.94745 13.083V15.3876H2.57484V7.56519C2.57484 7.48928 2.62579 7.38854 2.71118 7.32351L8.98248 2.79882L15.2546 7.35735C15.3401 7.42238 15.3912 7.52326 15.3912 7.59926Z"
      strokeWidth="0.5"
    />
  </svg>
);

export const BurgerSVGIcon = () => {
  return (
    <svg
      className="burger-svg-icon svg-icon"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect className="fill" y="11" width="32" height="2" rx="1" />
      <rect className="fill" y="19" width="32" height="2" rx="1" />
    </svg>
  );
};

export const CloseBackButtonSVGIcon = () => {
  return (
    <svg
      className="close-back-button-svg-icon svg-icon"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg">
      <path
        className="fill"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5858 0.585786C13.3668 -0.195262 14.6332 -0.195262 15.4142 0.585786C16.1953 1.36683 16.1953 2.63316 15.4142 3.41421L10.8284 8L15.4142 12.5858C16.1953 13.3668 16.1953 14.6332 15.4142 15.4142C14.6332 16.1953 13.3668 16.1953 12.5858 15.4142L8 10.8284L3.41421 15.4142C2.63317 16.1953 1.36684 16.1953 0.585787 15.4142C-0.195262 14.6332 -0.195262 13.3668 0.585787 12.5858L5.17157 8L0.585787 3.41421C-0.195261 2.63316 -0.195261 1.36683 0.585787 0.585786C1.36684 -0.195262 2.63317 -0.195262 3.41421 0.585786L8 5.17157L12.5858 0.585786Z"
      />
    </svg>
  );
};
